module.exports = [{
      plugin: require('/home/deploy/guide/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-55446531-6"},
    },{
      plugin: require('/home/deploy/guide/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
